import React, { memo } from 'react'

import Text from '../shared/text/Text'
import CustomAccordion from '../shared/customAccordion/CustomAccordion'
import BaseCard from '../shared/baseCard/BaseCard'

const FAQs = ({ t }) => {
  const data = [
    {
      title: 'What is the QBX token?',
      description: (
        <>
          <p>
            qiibee is the decentralized payment infrastructure for the $500bn
            rewards economy.
          </p>
          <p>
            The QBX is the equivalent of the Ethereum Gas for the qiibee Rewards
            Chain and serves as an incentive mechanism to reward nodes to verify
            all transactions and to secure the network. Every transaction
            connected to creating, earning, spending and exchanging loyalty
            tokens or loyalty NFTs needs to be triggered with the QBX.
            Businesses buy the QBX to trigger these transactions and part of
            these QBX fees generated are then distributed over the nodes that
            secure the network.
          </p>
          <p>
            Holders of the QBX can stake their QBX in the QBX VIP Club, which is
            the exclusive loyalty program of the qiibee foundation, to gain
            loyalty points and access thousands of rewards from the brands they
            love. The more QBX they stake, the higher their tier, which unlocks
            more rewards in the form of additional QBX, gift cards, physical
            products, airline miles, crypto, charity, VIP experiences and other
            perks.
          </p>
          <p>The QBX is an ERC-20 Ethereum based token.</p>
        </>
      )
    },
    {
      title: 'Who is eligible to claim QBX tokens?',
      description: (
        <p>
          The QBX tokens are claimable by early supporters, strategic partners,
          team members, advisors, and community members who have contributed to
          the development and growth of the qiibee ecosystem.
        </p>
      )
    },
    {
      title: 'Am I eligible to claim QBX tokens?',
      description: (
        <p>
          To check your eligibility for QBX tokens, simply connect your wallet.
          If you see a blue &quot;Claim&quot; button, you are eligible to claim
          your tokens.
        </p>
      )
    },
    {
      title: 'How do I claim my QBX tokens?',
      description: (
        <ol type='1'>
          <li>Click the blue &quot;Connect wallet&quot; button</li>
          <li>Select your preferred wallet to connect</li>
          <li>
            Once connected, you will see your QBX token allocation and vesting
            schedule
          </li>
          <li>
            If you are eligible to claim QBX tokens, the blue &quot;Claim&quot;
            button will be active
          </li>
          <li>
            Click the blue &quot;Claim&quot; button and confirm that you want to
            unstake and claim your tokens
          </li>
          <li>
            Sign the transaction in your wallet by following the provided
            instructions
          </li>
          <li>
            After the transaction completes on-chain, your QBX tokens will
            appear in your wallet
          </li>
        </ol>
      )
    },
    {
      title: 'Can I claim all my QBX at once?',
      description: (
        <p>
          No. The QBX tokens are locked in vesting smart contracts. Depending on
          your vesting schedule, you can claim a portion of your total QBX
          tokens on the listing day and claim the rest of the tokens linearly
          thereafter.
        </p>
      )
    },
    {
      title: 'Why are my QBX tokens locked?',
      description: (
        <p>
          The tokens are locked to create a healthy and sustainable market for
          QBX and demonstrate long-term commitment from our community, strategic
          holders, team, and foundation. Even during the vesting period, tokens
          remain fully functional—you can use your QBX to secure a tier in the
          QBX VIP Club, access our loyalty solutions, and utilize the qiibee
          rewards chain to create your own loyalty program.
        </p>
      )
    },
    {
      title: 'Are there gas fees for claiming my QBX?',
      description: (
        <p>
          Yes. When claiming QBX tokens from the smart contract to your wallet,
          you&apos;ll need to pay Ethereum gas fees. These fees vary based on
          network activity and are beyond our control.
        </p>
      )
    },
    {
      title: 'How does the staking work, and why should I stake my QBX tokens?',
      description: (
        <>
          <p>
            Your QBX tokens are considered &quot;staked&quot; as long as they
            remain unclaimed in the smart contract. Weekly snapshots of your
            wallet determine your staked amount.
          </p>

          <p>
            Staking your QBX tokens earns you a 36% APR reward that can be
            claimed weekly.
          </p>

          <p>
            It is free to keep your QBX tokens unclaimed on the smart contract.
          </p>
        </>
      )
    },
    {
      title: 'Is there a deadline to claim my QBX tokens?',
      description: (
        <p>
          As long as the above mentioned vesting schedule is active, you can
          claim your QBX tokens from the smart contracts whenever you prefer.
        </p>
      )
    },
    {
      title: 'Can I transfer my QBX tokens after claiming them?',
      description: (
        <p>
          Yes. After claiming your QBX tokens into your wallet, you can freely
          transfer them.
        </p>
      )
    },
    {
      title: 'Are the claiming smart contracts secure?',
      description: (
        <p>
          Yes. In order to ensure that the QBX tokens are secure, the claiming
          smart contracts have been thoroughly audited by CertiK.
        </p>
      )
    },
    {
      title: 'I am encountering issues, what do I do?',
      description: (
        <>
          <p>
            If any of the following topics apply to you,{' '}
            <strong>
              <a
                href='https://app.deform.cc/form/c610c353-03f9-4499-bc9c-c6f9648634c8'
                target='_blank'
                rel='noreferrer'
              >
                fill out this form
              </a>
            </strong>{' '}
            and we will help you as fast as we can.
          </p>
          <ul>
            <li>
              My wallet does not have a $QBX allocation when I connect it.
            </li>
            <li>
              I don&apos;t see the correct $QBX allocation amount when I connect
              my wallet.
            </li>
            <li>
              I still have my beta-test QBX and forgot to migrate in past two
              years.
            </li>
            <li>I&apos;m lost, help!</li>
          </ul>
        </>
      )
    }
  ]
  return (
    <BaseCard id='faqs'>
      <Text
        variant='h2'
        label={t('home.faqs')}
        fontWeight={700}
        sx={{ mb: 2 }}
      />
      <CustomAccordion data={data} />
    </BaseCard>
  )
}

export default memo(FAQs)
